import { Tooltip } from '@orbita-ui/core';
import { HeaderButton } from '../AppHeader/AppHeader.styles';
import { useAuth } from 'auth/hooks/useAuth';
import { AppIcon } from 'shared/icons/AppIcon';
import { useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from 'user/routes';

export const LogoutButton = () => {
  const { logout, exitImpersonation, user } = useAuth();
  const navigate = useNavigate();

  const logoutHandler = () => {
    if (user?.impersonation) {
      exitImpersonation();
    } else {
      logout();
      navigate(LOGIN_PATH);
    }
  };

  return (
    <HeaderButton onClick={() => logoutHandler()}>
      <Tooltip position="left" text="Cerrar Sesión">
        <AppIcon name="LogOutIcon" />
      </Tooltip>
    </HeaderButton>
  );
};
